export const CERT_ERROR_CD = 'RESP001';
export const PROD_ERROR_CD = 'RESP002';

export const API_SUCCESS_CD = 'RESP000';
